/**
 * NOTE: For compatibility across platforms all calls **must** return a
 * `Promise` object!
 */

import { PmcMessageType } from '@reachmedianetwork/post-message-client-rds-api';
import { PlayerPmc } from '../PlayerPmc';

export type SystemUpdateObject = {
    /**
     *
     */
    isEnabled: boolean;

    /**
     * The date to run the update (ie. 'sunday')
     */
    day: string;

    /**
     * The time of day to run the update (format: 'H:mm:ss')
     */
    time: string;

    /**
     * (format: 'YYYY-MM-DD HH:mm:ss')
     */
    lastUpdated: null | string;
};

export interface UpdateInterface {
    /**
     * **Feature:** Start a `Scheduler` to update the platform's system.
     */
    schedulePlatformUpdate(systemUpdate: SystemUpdateObject): Promise<void> | void;
}

export function supportsSystemUpdate(platform: unknown): platform is UpdateInterface {
    if (platform instanceof PlayerPmc) {
        return platform.supportsMessage(PmcMessageType.SchedulePlatformUpdate);
    }
    return platform instanceof Object && 'schedulePlatformUpdate' in platform;
}
